import { FC, useMemo, useRef } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import { useModal } from 'context/ModalProvider/useModal';
import { Button } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { EditOfflineRequestsModal } from './modal';

export const OfflineRequestsScreen: FC = () => {
  const { showModal } = useModal();
  const requestDateSource: any = useMemo(() => $createStore('/v1/OfflineRequestWork', 'id'), []);

  const refGrid = useRef<DataGrid | null>(null);

  const handleRefresh = () => {
    refGrid.current?.instance.refresh();
  };

  const handleEditRow = (id: number) => {
    showModal(<EditOfflineRequestsModal id={id} onRefresh={handleRefresh} />);
  };

  return (
    <div className="container-dev">
      <AppLayoutTop title="Оффлайн заявки"></AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={requestDateSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <Export enabled={true} />
          <StateStoring enabled={true} type="localStorage" storageKey="offlineRequests" />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="printNumber" caption="Номер" width={80} />
          <Column dataField="object" caption="Объект" />
          <Column
            width={180}
            defaultSortOrder="desc"
            sortOrder="desc"
            dataField="completedDate"
            caption="Дата"
            dataType="date"
          >
            <HeaderFilter groupInterval="day" />
          </Column>
          <Column dataField="nomenclatureName" caption="Марка (Плотность)" dataType="string" />
          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="driver" caption="Водитель" />
          <Column dataField="operator" caption="Оператор" />
          <Column dataField="contractor" caption="Заказчик" />
          <Column dataField="quantity" caption="Объём" dataType="number" width="90" />
          <Column dataField="factoryName" caption="Завод" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    handleEditRow(data.data.id);
                  }}
                />
              </>
            )}
          />

          <Paging defaultPageSize={100} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};
